import SearchspringListingBase from "@theme/searchspring-base";
import { getSearchExpansionConfig } from "@theme/searchspring-variant-engine";

export default class CollectionResultsList extends SearchspringListingBase {
  constructor() {
    super();
    this.initVisualFilters();
  }

  initContext() {
    this.collectionHandle = this.dataset.collectionHandle;
    const params = new URLSearchParams(window.location.search);

    const pageFromUrl = parseInt(params.get('page'));
    this.currentPage = (pageFromUrl && pageFromUrl > 1) ? pageFromUrl : 1;

    const filterParams = new URLSearchParams();
    for (const [key, value] of params.entries()) {
      // Skip system parameters
      if (key === 'page' || key === 'sort_by' || key === 'q') {
        continue;
      }
      
      // Check if it's already a technical field (starts with 'filter.')
      if (key.startsWith('filter.')) {
        filterParams.append(key, value);
      } else {
        // Try to convert pretty URL slug to technical field
        const technicalField = SearchspringListingBase.urlToFilterField(key);
        if (technicalField && technicalField.startsWith('filter.')) {
          filterParams.append(technicalField, value);
        }
      }
    }

    this.activeFilters = filterParams.toString();
  }

  async initExpansionConfig() {
    const config = getSearchExpansionConfig();

    this.enableExpansion = config.enableExpansion;
    this.resultsPerPage = config.resultsPerPage;
    this.oosSortingRule = config.oosSortRule;
    this.variantSortOverride = config.variantSortOverride;
    this.saleColorName = config.saleColorName;
    this.saleColorId = config.saleColorId;
    this.displayNonSaleVariants = config.displayNonSaleVariants;
  }

  shouldPushCollectionViewItemList() {
    return true;
  }

  initVisualFilters() {
    const filterTiles = document.querySelectorAll('[data-visual-filter-tile]');

    filterTiles.forEach(tile => {
      tile.addEventListener('click', (e) => {
        const urlString = tile.getAttribute('href');
        const isFilterOnly = urlString.startsWith('filter.');
        const targetUrl = new URL(urlString, window.location.origin);
        const isSamePage = targetUrl.pathname === window.location.pathname;

        if (isFilterOnly || isSamePage) {
          e.preventDefault();

          const newFullUrl = isFilterOnly
            ? `${window.location.pathname}?${urlString}`
            : targetUrl.href;

          window.history.pushState({}, '', newFullUrl);

          this.initContext();
          this.currentPage = 1;
          this.loadFilteredResults();

          filterTiles.forEach(t => t.classList.remove('is-active'));
          tile.classList.add('is-active');
        }
      });
    });
  }

  getEndpoint() {
    return 'category.json';
  }

  getBeaconPath() {
    return 'category';
  }

  getBaseParams(page) {
    return {
      ...super.getBaseParams(page),
      "bgfilter.collection_handle": this.collectionHandle,
      redirectResponse: 'minimal'
    };
  }
}

if (!customElements.get('collection-results-list')) {
  customElements.define('collection-results-list', CollectionResultsList);
}